import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { HttpService, API, swal, toast, Title, Messages } from '../../config/react'
import Spinner from '../Spinner'

const CacheManagement = () => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    document.title = Title.CacheManagement
    GetCacheManagementList()
  }, [])

  const GetCacheManagementList = () => {
    HttpService.getApi(API.getcachekeys).then((response) => {
      setLoading(false)
      setData(response.data.result)
    })
  }

  const GenerateCache = (e, key) => {
    e.preventDefault()
    setLoading(true)
    const param = {
      key
    }

    HttpService.postApi(API.generatecachekey, param)

      .then((response) => {
        toast.success(Messages.GenerateCache)
        setLoading(false)
        GetCacheManagementList()
      })
      .catch((error) => {
        toast.success('Something went wrong.' + error)
        setLoading(false)
      })
  }

  const ClearCache = (e, key) => {
    e.preventDefault()
    swal(Messages.CahcheclearProp).then(function (isConfirm) {
      if (isConfirm) {
        const param = {
          key
        }

        HttpService.postApi(API.removecachebykeys, param).then((response) => {
          toast.success(Messages.CacheClear)
          GetCacheManagementList()
        })
      }
    })
  }
  const Rest = ({ item, key }) => {
    if (item === 'Products' || item === 'Diamonds' || item === 'Diamond Combinations')
      return [
        <span key={key}>|</span>,
        <Link
          key={key}
          to="#"
          onClick={(e) => ResetCache(item)}
        >
          {' '}
          Reset{' '}
        </Link>
      ]
    else return ''
  }
  const ResetCache = (key) => {
    const param = {
      key
    }
    HttpService.postApi(API.ResetCache, param).then((response) => {
      toast.success(Messages.ResetCache)
    })
  }

  const ClearAll = () => {
    swal(Messages.CahcheclearProp).then(function (isConfirm) {
      if (isConfirm) {
        HttpService.getApi(API.removeAllCache).then((response) => {
          toast.success(Messages.CacheClear)
          GetCacheManagementList()
        })
      }
    })
  }
  const ProductSync = () => {
    HttpService.postApi(API.SyncProduct).then((response) => {
      try {
        toast.success(Messages.ResponseSend)
      } catch (error) {
        toast.warning(Messages.Error)
      }
    })
  }
  return loading ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title"> {Title.CacheManagement} </h3>
        <div className="btn-group">
          <button
            type="button"
            className="btn btn-dark btn-fw rounded mr-2"
            onClick={ProductSync}
          >
            {' '}
            {'Sync Product'}
            {/* <i
              class="fa fa-refresh"
              aria-hidden="true"
            ></i> */}
          </button>
          <button
            type="button"
            className="btn btn-dark btn-fw rounded mr-2"
            onClick={ClearAll}
          >
            {' '}
            Clear All{' '}
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <div className="table-responsive">
                  <table className="table text-center">
                    <thead className="bg-custom">
                      <tr>
                        <th>Cache Type</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.keys(data).map((item, index) => (
                        <tr key={index}>
                          <td>{data[item].replace(/_/g, ' ')}</td>
                          <td className="action-link">
                            <Link
                              to="#"
                              onClick={(e) => GenerateCache(e, item)}
                            >
                              Generate{' '}
                            </Link>
                            |
                            <Link
                              to="#"
                              onClick={(e) => ClearCache(e, item)}
                            >
                              {' '}
                              Clear{' '}
                            </Link>
                            <Rest item={data[item]}></Rest>
                            {/* { data[item] == 'Products' && [<span>|</span>, <Link to="#" onClick={e => ResetCache(item)}> Reset </Link>]} */}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default CacheManagement
